import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { theme, colors } from '../../theme'
import { StripeConnectButton } from '../../Adopters/StripeConnectButton'

const OfferTabs: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <Box sx={{ maxWidth: '100%', margin: 'auto', textAlign: 'center', mt: 4 }}>
      <Box
        sx={{
          mt: 2,
          mb: 3,
          width: '100%',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          px: { xs: 1.5, md: 2.5 },
          pb: { xs: 2, md: 2.5 },
          pt: { xs: 2, md: 2.35 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'stretch', md: 'center' },
            justifyContent: 'space-between',
            gap: 2,
            mb: 1.1,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: 18, md: 21.6 },
              color: colors.blue,
              textAlign: 'left',
            }}
          >
            Offre gratuite & pourboires facultatifs
          </Typography>
          <StripeConnectButton
            content="Configurer mon Stripe Connect"
            color="secondary"
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '999px',
              px: 3,
              alignSelf: { xs: 'stretch', md: 'center' },
              flexShrink: 0,
              boxShadow: 'none',
            }}
            fullWidth={isMobile}
          />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: '0.88rem', md: '0.96rem' },
            fontWeight: 500,
            textAlign: 'left',
            color: theme.palette.secondary.main,
            lineHeight: { xs: 1.45, md: 1.35 },
          }}
        >
          <Box component="span" sx={{ display: 'block', color: colors.cello, fontWeight: 600 }}>
            Pour chaque demande d&apos;adoption, vos adoptants peuvent régler en ligne via un espace dédié.
          </Box>
          <Box component="span" sx={{ display: 'block', mt: 0.5 }}>
            Paiement sécurisé avec{' '}
            <Box
              component="a"
              href="https://stripe.com/fr"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit', textDecoration: 'underline', fontWeight: 700 }}
            >
              Stripe
            </Box>
            , 100% du montant reversé à l’association.
          </Box>
          <Box component="span" sx={{ display: 'block', mt: 0.35 }}>
            Les pourboires facultatifs aident à maintenir Petso gratuit pour les associations.
          </Box>
          <Box component="span" sx={{ display: 'block', mt: 0.35, fontWeight: 700 }}>
            Une fois Stripe Connect configuré, documents et suivi santé restent illimités sur chaque fiche animal.
          </Box>

          <Box
            component="span"
            sx={{
              display: 'block',
              mt: 1.5,
              px: 1.25,
              py: 1,
              borderRadius: '12px',
              backgroundColor: '#F6F8FC',
              border: '1px solid #E2E8F2',
              color: colors.cello,
              fontWeight: 700,
            }}
          >
            Pour activer les règlements en ligne et renseigner votre compte de versement, configurez votre{' '}
            <Box
              component="a"
              href="https://stripe.com/fr"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit', textDecoration: 'underline' }}
            >
              Stripe
            </Box>{' '}
            x Petso (~3&nbsp;min) puis lancez une procédure d&apos;adoption sur Petso.
          </Box>
        </Typography>
      </Box>
    </Box>
  )
}

export default OfferTabs
